import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const MultipleUsersSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23.5" height="15.5" viewBox="0 0 23.5 15.5" className={className}>
    <g transform="translate(0.75 0.75)">
      <path d="M18,19V18a4,4,0,0,0-4-4H10a4,4,0,0,0-4,4v1m17,0V18a4,4,0,0,0-4-4h-.5M1,19V18a4,4,0,0,1,4-4h.5M17,11a3,3,0,0,0,0-6M7,11A3,3,0,0,1,7,5m8,3a3,3,0,1,1-3-3A3,3,0,0,1,15,8Z" transform="translate(-1 -5)"/>
    </g>
  </svg>
);